import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import { HTMLAttributeAnchorTarget } from "react";
import { ResolvedTertiaryLink } from "resolvers/data/header/menuResolver";
import styles from "./MainMenuContainer.module.scss";

const cx = classNames.bind(styles);

export type FloatingLink = {
    text: string;
    path: string;
    target: HTMLAttributeAnchorTarget;
    showOnlyWhenLoggedIn: boolean;
    onClick?: () => void;
};

type Props = {
    items: ResolvedTertiaryLink[];
    title: string;
    overrideMenuClassName?: string;
    isLoggedIn: boolean;
    floatingLink?: FloatingLink;
};

export const MainMenuContainer = ({
    items,
    title,
    overrideMenuClassName,
    isLoggedIn,
    floatingLink,
}: Props) => {
    const floatingLinkOnlyWhenLoggedIn = !!(floatingLink && floatingLink.showOnlyWhenLoggedIn);
    const showFloatingLink = floatingLinkOnlyWhenLoggedIn ? isLoggedIn : true;

    return (
        <div className={cx("container", overrideMenuClassName)}>
            {floatingLink && showFloatingLink && (
                <SmartLink href={floatingLink.path}>
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            floatingLink?.onClick?.();
                            window.location.href = floatingLink.path;
                        }}
                        target={floatingLink.target}
                        className={cx("floatingLink")}
                    >
                        {floatingLink.text}
                    </a>
                </SmartLink>
            )}
            {title && <span className={cx("title")}>{title}</span>}
            <ul role="menu" aria-labelledby="menubutton" className={cx("list")}>
                {items.map(({ path, linkText }) => (
                    <li key={path} role="menuitem" className={cx("listItem")}>
                        <div className={cx("listItemTextWrapper")}>
                            <SmartLink href={path}>
                                <a>
                                    <span className={cx("listItemText")}>{linkText}</span>
                                </a>
                            </SmartLink>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};
